import React, { useEffect, useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Autocomplete, TextField } from '@mui/material';
import { GetCategorylist, GetAnalystlist, useInvoiceParentFiltersDashboard, useDashboardChildFilters } from './hooks';
import { useDispatch, useSelector } from 'react-redux';
import FltrClientName from './client-name-flt';
import FilterVendorName from './vendor-name';
import FilterBatchName from './batch-name';
import FilterInvoiceName from './invoice-name';
import FilterFieldName from './field-name';
import FilterInvoiceStatus from './invoice-status';
import { reset_filter, save_filter } from './dashboard-slice';
import { sortDropdownOptions } from '../utils';

export default function DateFilter({
	get_dashboard_hook,
	get_mismatches_hook,
	get_datafield_hook,
	sendDataToParent,
	get_datavalidationerror_hook,
	get_unmapped_price_hook,
	sendDataToParent2,
	sendDataToParent3,
}) {
	const [fromValue, setFromValue] = React.useState();
	const [ToValue, setToValue] = React.useState();

	const category_list_hook = GetCategorylist();
	const analyst_list_hook = GetAnalystlist();

	const [, setFocus] = useState(false);

	

	const [FieldName, setFieldName] = useState();
	const [FieldNameId, setFieldNameId] = useState(null);

	const Data = useSelector((p) => p.dashSlice);
	const firstTime = useRef(true);
	const restoreFromRedux = useRef(false);

	const [selectedVendor, setSelectedVendor] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('');
	const [selectedClient, setSelectedClient] = useState('');
	const [Filters, setFilters] = useState([]);
	const getfilterHook = useInvoiceParentFiltersDashboard();
	const getChildFiltersHook = useDashboardChildFilters();

	const [childFilters, setChildFilters] = useState([]);
	const [selectedUploadedBy, setSelectedUploadedBy] = useState(null);
	const [selectedDispStatus, setSelectedDispStatus] = useState(null);
	const [selectedBatch, setSelectedBatch] = useState(null);
	const [selectedFname, setSelectedFname] = useState(null);

	useEffect(() => {
		if (getfilterHook?.data) {
			setFilters(getfilterHook.data.data);
		}
	}, [getfilterHook?.data, getfilterHook?.isSuccess]);

	useEffect(() => {
		if (selectedCategory && selectedClient && selectedVendor) {
			console.log(selectedVendor , "sel");
			
			const bd = {
				client_id: selectedClient.client_id,
				vendor_id: selectedVendor.vendor_id,
				category_id: selectedCategory.category_id,
			};
			setChildFilters([]);
			
			getChildFiltersHook.mutate(bd);
			
		}
	}, [selectedCategory, selectedClient, selectedVendor]);

	useEffect(() => {
		if (getChildFiltersHook.isSuccess && getChildFiltersHook.data) {
			setChildFilters(getChildFiltersHook.data?.data);
		}
	}, [getChildFiltersHook.isSuccess, getChildFiltersHook.data]);

	const dispatch = useDispatch();
	function setDebounceSearch() {
		const fieldName = encodeURIComponent(FieldNameId);
		get_dashboard_hook.mutate({
			analyst: selectedUploadedBy?.uploaded_by || null,
			category: selectedCategory?.category_id || null,
			client: selectedClient?.client_id || null,
			vendor: selectedVendor?.vendor_id || null,
			invoice: selectedFname?._id || null,
			field: fieldName || null,
			batch: selectedBatch?.batch_id || null,
			invoice_status: selectedDispStatus?.disp_status || null,
			datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
			dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
		});
		//get_invoice_need_attention_hook.mutate({ analyst: AnalystId, category: CategoryId, datefrom: (fromValue) ? dayjs(fromValue.$d).format("MM-DD-YYYY") : null, dateto: (ToValue) ? dayjs(ToValue.$d).format("MM-DD-YYYY") : null });
		get_mismatches_hook.mutate({
			analyst: selectedUploadedBy?.uploaded_by || null,
			category: selectedCategory?.category_id || null,
			client: selectedClient?.client_id || null,
			vendor: selectedVendor?.vendor_id || null,
			invoice: selectedFname?._id || null,
			field: fieldName || null,
			batch: selectedBatch?.batch_id || null,
			invoice_status: selectedDispStatus?.disp_status || null,
			datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
			dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
		});

		//console.log(FieldNameId);
		if (FieldNameId) {
			sendDataToParent({
				show: true,
				analyst: selectedUploadedBy?.uploaded_by || null,
				category: selectedCategory?.category_id || null,
				client: selectedClient?.client_id || null,
				vendor: selectedVendor?.vendor_id || null,
				invoice: selectedFname?._id || null,
				field: fieldName || null,
				batch: selectedBatch?.batch_id || null,
				invoice_status: selectedDispStatus?.disp_status || null,
				datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
				dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
			});

			get_datafield_hook.mutate({
				analyst: selectedUploadedBy?.uploaded_by || null,
				category: selectedCategory?.category_id || null,
				client: selectedClient?.client_id || null,
				vendor: selectedVendor?.vendor_id || null,
				invoice: selectedFname?._id || null,
				field: fieldName || null,
				batch: selectedBatch?.batch_id || null,
				invoice_status: selectedDispStatus?.disp_status || null,
				datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
				dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
			});
		} else {
			sendDataToParent({ show: false });
		}

		//console.log(InvoiceNameId);

		if (selectedUploadedBy || selectedCategory || selectedClient || selectedVendor) {
			sendDataToParent2({
				show: true,
				analyst: selectedUploadedBy?.uploaded_by || null,
				category: selectedCategory?.category_id || null,
				client: selectedClient?.client_id || null,
				vendor: selectedVendor?.vendor_id || null,
				invoice: selectedFname?._id || null,
				field: fieldName || null,
				batch: selectedBatch?.batch_id || null,
				invoice_status: selectedDispStatus?.disp_status || null,
				datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
				dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
			});

			get_datavalidationerror_hook.mutate({
				analyst: selectedUploadedBy?.uploaded_by || null,
				category: selectedCategory?.category_id || null,
				client: selectedClient?.client_id || null,
				vendor: selectedVendor?.vendor_id || null,
				invoice: selectedFname?._id || null,
				field: fieldName || null,
				batch: selectedBatch?.batch_id || null,
				invoice_status: selectedDispStatus?.disp_status || null,
				datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
				dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
			});
		} else {
			sendDataToParent2({ show: false });
		}

		get_unmapped_price_hook.mutate({
			analyst: selectedUploadedBy?.uploaded_by || null,
			category: selectedCategory?.category_id || null,
			client: selectedClient?.client_id || null,
			vendor: selectedVendor?.vendor_id || null,
			invoice: selectedFname?._id || null,
			field: fieldName || null,
			batch: selectedBatch?.batch_id || null,
			invoice_status: selectedDispStatus?.disp_status || null,
			datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
			dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
		});

		sendDataToParent3({
			show: true,
			analyst: selectedUploadedBy?.uploaded_by || null,
			category: selectedCategory?.category_id || null,
			client: selectedClient?.client_id || null,
			vendor: selectedVendor?.vendor_id || null,
			invoice: selectedFname?._id || null,
			field: fieldName || null,
			batch: selectedBatch?.batch_id || null,
			invoice_status: selectedDispStatus?.disp_status || null,
			datefrom: fromValue ? dayjs(fromValue.$d).format('MM-DD-YYYY') : null,
			dateto: ToValue ? dayjs(ToValue.$d).format('MM-DD-YYYY') : null,
		});

		saveFilters();
	}

	function restoreFilters(filter) {
		if (filter) {
			console.log(filter, "FILTER");
			
			setSelectedUploadedBy( filter.analyst ? { uploaded_by: filter.analyst, uploaded_by_name: filter.analystName } : null );
			setSelectedClient( filter.client ? { client_id: filter.client, client: filter.clientName } : null );
			setSelectedVendor( filter.vendor ? { vendor_id: filter.vendor, vendor: filter.vendorName } : null );
			setSelectedCategory( filter.category ? { category_id: filter.category, category_name: filter.categoryName } : null );
			setSelectedFname( filter.invoice ? { _id: filter.invoice, fname: filter.invoiceName } : null );
			setSelectedDispStatus( filter.invoice_status ? { disp_status: filter.invoice_status } : null );

			
			setFieldNameId(filter.fieldNameId);
			setFieldName(
				filter.fieldNameId !== null
					? { entity_name: decodeURIComponent(filter.fieldNameId) }
					: null
			);
			setSelectedBatch( filter.batch ? { batch_id: filter.batch, batch: filter.batchName } : null );
			setSelectedDispStatus( filter.invoice_status ? { disp_status: filter.invoice_status } : null );
			setFromValue(filter?.datefrom ? dayjs(filter.datefrom) : undefined);
			setToValue(filter?.dateto ? dayjs(filter.dateto) : undefined);
			restoreFromRedux.current = true;
		}
	}
	const resetFilters = () => {
		
		setSelectedClient(null);
		setSelectedVendor(null);
		setSelectedCategory(null);

		setSelectedUploadedBy(null);
		setSelectedFname(null);
		setSelectedBatch(null);
		setSelectedDispStatus(null);
		setFieldName(null);
		setFieldNameId(null);

		setFromValue(undefined);
		setToValue(undefined);
		get_mismatches_hook.mutate({
			analyst: null,
			category: null,
			client: null,
			vendor: null,
			invoice: null,
			field: null,
			batch: null,
			invoice_status: null,
			datefrom: null,
			dateto: null,
		});
		get_dashboard_hook.mutate({
			analyst: null,
			category: null,
			client: null,
			vendor: null,
			invoice: null,
			field: null,
			batch: null,
			invoice_status: null,
			datefrom: null,
			dateto: null,
		});
		get_unmapped_price_hook.mutate({
			analyst: null,
			category: null,
			client: null,
			vendor: null,
			invoice: null,
			field: null,
			batch: null,
			invoice_status: null,
			datefrom: null,
			dateto: null,
		});
		//get_datafield_hook.mutate({analyst: null, category: null, client:null, vendor:null, invoice:null, field:null, batch:null, invoice_status:null, datefrom: null, dateto: null});
		//get_datavalidationerror_hook.mutate({analyst: null, category: null, client:null, vendor:null, invoice:null, field:null, batch:null, invoice_status:null, datefrom: null, dateto: null});

		sendDataToParent2({ show: false });
		sendDataToParent({ show: false });
		dispatch(reset_filter());
	};

	useEffect(() => {
		restoreFilters(Data);
	}, []);

	function saveFilters() {
		let payload = {
			analyst: selectedUploadedBy?.uploaded_by || null,
			analystName: selectedUploadedBy?.uploaded_by_name || null,
			category: selectedCategory?.category_id || null,
			categoryName: selectedCategory?.category_name || null,
			client: selectedClient?.client_id || null,
			clientName: selectedClient?.client || null,
			vendor: selectedVendor?.vendor_id || null,
			vendorName: selectedVendor?.vendor || null,
			invoice: selectedFname?._id || null,
			invoiceName: selectedFname?.fname || null,
			fieldNameId: FieldNameId || null,
			batch: selectedBatch?.batch_id || null,
			batchName: selectedBatch?.batch || null,
			invoice_status: selectedDispStatus?.disp_status || null,
			datefrom: fromValue || null,
			dateto: ToValue || null,
		};
		dispatch(save_filter(payload));
	}

	useEffect(() => {
		if (firstTime.current) {
			firstTime.current = false;
			return;
		} else if (restoreFromRedux.current) {
			restoreFromRedux.current = false;
			return;
		}

		setSelectedUploadedBy(null);
		setSelectedFname(null);
		setSelectedBatch(null);
		setSelectedDispStatus(null);
		setFieldName(null);
		setFieldNameId(null);

	}, [selectedClient, selectedVendor, selectedCategory]);

	function getUniqueClients(
		lst,
		selectedVendor = null,
		selectedCategory = null
	) {
		const uniqueClients = [];
		const seenClientIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedVendor && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedVendor && selectedCategory) {
					return (
						item.vendor_id === selectedVendor?.vendor_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedCategory) {
					return item.category_id === selectedCategory?.category_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenClientIds.has(item.client_id)) {
					seenClientIds.add(item.client_id);
					uniqueClients.push({
						client_id: item.client_id,
						client: item.client,
					});
				}
			});

		return sortDropdownOptions(uniqueClients, (o) => o.client);
	}

	function getUniqueVendors(
		lst,
		selectedClient = null,
		selectedCategory = null
	) {
		const uniqueVendors = [];
		const seenVendorIds = new Set();
		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedCategory) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedCategory) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.category_id === selectedCategory?.category_id
					);
				}
				// If only vendor selected
				if (selectedCategory) {
					return item.category_id === selectedCategory?.category_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenVendorIds.has(item.vendor_id)) {
					seenVendorIds.add(item.vendor_id);
					uniqueVendors.push({
						vendor_id: item.vendor_id,
						vendor: item.vendor,
					});
				}
			});

		return sortDropdownOptions(uniqueVendors, (o) => o.vendor);
	}

	function getUniqueCategories(
		lst,
		selectedVendor = null,
		selectedClient = null
	) {
		const uniqueCategories = [];
		const seenCategoryIds = new Set();

		lst
			?.filter((item) => {
				// If no vendor or category selected, include all
				if (!selectedClient && !selectedVendor) return true;
				// If both vendor and category selected, match both
				if (selectedClient && selectedVendor) {
					return (
						item.client_id === selectedClient?.client_id &&
						item.vendor_id === selectedVendor?.vendor_id
					);
				}
				// If only vendor selected
				if (selectedVendor) {
					return item.vendor_id === selectedVendor?.vendor_id;
				}
				// If only category selected
				if (selectedClient) {
					return item.client_id === selectedClient?.client_id;
				}
				return true;
			})
			?.forEach((item) => {
				if (!seenCategoryIds.has(item.category_id)) {
					seenCategoryIds.add(item.category_id);
					uniqueCategories.push({
						category_id: item.category_id,
						category_name: item.category_name,
					});
				}
			});

		return sortDropdownOptions(uniqueCategories, (o) => o.category_name);
	}

	const uniqueClients = useMemo(
		() => getUniqueClients(Filters, selectedVendor, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueVendors = useMemo(
		() => getUniqueVendors(Filters, selectedClient, selectedCategory),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);
	const uniqueCategories = useMemo(
		() => getUniqueCategories(Filters, selectedVendor, selectedClient),
		[Filters, selectedClient, selectedVendor, selectedCategory]
	);

	function getUniqueValues(lst, key, filters) {
		const uniqueValues = [];
		const seenIds = new Set();

		lst
			.filter((itm) => itm[key])
			.filter((itm) => {
				return filters.every((filter) => {
					if (!filter.value) {
							return true;
						}
					if (filter.key =='uploaded_by') {
						return itm[filter.key] == filter.value.uploaded_by
					}

					else if (filter.key =='disp_status') { 
						return itm[filter.key] == filter.value.disp_status
					}
					else if (filter.key == 'batch') { 
						return itm['batch_id'] == filter.value.batch_id
					}

					else if (filter.key =='fname') { 
						return itm[filter.key] == filter.value.fname

					}
				});
			})
			?.forEach((item) => {
				if (!seenIds.has(item[key])) {
					seenIds.add(item[key]);
					uniqueValues.push(item);
				}
			});
		return sortDropdownOptions(uniqueValues, (item) => {
			if (key === 'uploaded_by') return item.uploaded_by_name;
			if (key === 'batch_id') return item.batch;
			return item[key];
		});
	}

	const uniqueUploadedBy = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'uploaded_by',
				[
					// { key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'disp_status', value: selectedDispStatus },
					{ key: 'batch', value: selectedBatch },
					{ key: 'fname', value: selectedFname },
				]
			),
		[
			childFilters,
			selectedUploadedBy,
			selectedDispStatus,
			selectedBatch,
			selectedFname,
		]
	);

	const uniqueDispStatus = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'disp_status',
				[
					{ key: 'uploaded_by', value: selectedUploadedBy },
					// { key: 'disp_status', value: selectedDispStatus },
					{ key: 'batch', value: selectedBatch },
					{ key: 'fname', value: selectedFname },
				]
			),
		[
			childFilters,
			selectedUploadedBy,
			selectedDispStatus,
			selectedBatch,
			selectedFname,
		]
	);

	const uniqueBatches = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'batch_id',
				[
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'disp_status', value: selectedDispStatus },
					// { key: 'batch', value: selectedBatch },
					{ key: 'fname', value: selectedFname },
				]
			),
		[
			childFilters,
			selectedUploadedBy,
			selectedDispStatus,
			selectedBatch,
			selectedFname,
		]
	);

	const uniqueFnames = useMemo(
		() =>
			getUniqueValues(
				childFilters,
				'fname',
				[
					{ key: 'uploaded_by', value: selectedUploadedBy },
					{ key: 'disp_status', value: selectedDispStatus },
					{ key: 'batch', value: selectedBatch },
					// { key: 'fname', value: selectedFname },
				]
			),
		[
			childFilters,
			selectedUploadedBy,
			selectedDispStatus,
			selectedBatch,
			selectedFname,
		]
	);

	

	console.log(selectedVendor , "SELECTED VENDOR");
	
	return (
		<>
			<div className="md:flex items-center gap-3 flex-wrap xl:flex-nowrap text-sm multiDashFltr">

				<div className="grow missDD">
					<Autocomplete
						id="category"
						options={uniqueCategories}
						getOptionLabel={(option) =>
							typeof option === 'string' ? option : option.category_name
						}
						isOptionEqualToValue={(option, value) =>
							option.category_id === value.category_id
						}
						value={selectedCategory}
						onChange={(event, newValue) => {
							setSelectedCategory(newValue);
						}}
						loading={getfilterHook.isFetching}
						loadingText="Loading..."
						renderInput={(params) => (
							<TextField {...params} label="Categories" fullWidth />
						)}
						renderOption={(props, option) => (
							<li {...props} key={option['category_id']}>
								{option['category_name']}
							</li>
						)}
						slotProps={{
							popper: {
								placement: 'bottom-start', 							
							},
						}}
					/>
				</div>

				<div className="grow missDD">
					<div className="lightT">
						<Autocomplete
							id="client"
							options={uniqueClients}
							getOptionLabel={(option) =>
								typeof option === 'string' ? option : option.client
							}
							isOptionEqualToValue={(option, value) =>
								option.client_id === value.client_id
							}
							value={selectedClient}
							onChange={(event, newValue) => {
								setSelectedClient(newValue);
							}}
							loading={getfilterHook.isFetching}
							loadingText="Loading..."
							renderInput={(params) => (
								<TextField {...params} label="Clients" fullWidth />
							)}
							renderOption={(props, option) => (
								<li {...props} key={option['client_id']}>
									{option['client']}
								</li>
							)}
							slotProps={{
								popper: {
									placement: 'bottom-start', 							
								},
							}}
						/>
					</div>
				</div>

				<div className="grow missDD">
					<div className="lightT">
						<Autocomplete
							id="vendor"
							options={uniqueVendors}
							getOptionLabel={(option) =>
								typeof option === 'string' ? option : option.vendor
							}
							isOptionEqualToValue={(option, value) =>
								option.vendor_id === value.vendor_id
							}
							value={selectedVendor}
							onChange={(event, newValue) => {
								setSelectedVendor(newValue);
							}}
							loading={getfilterHook.isFetching}
							loadingText="Loading..."
							renderInput={(params) => (
								<TextField {...params} label="Vendors" fullWidth />
							)}
							renderOption={(props, option) => (
								<li {...props} key={option['vendor_id']}>
									{option['vendor']}
								</li>
							)}
							slotProps={{
								popper: {
									placement: 'bottom-start', 							
								},
							}}
						/>
					</div>
				</div>

				{selectedClient && selectedVendor && selectedCategory && (
					<>
					<div className="grow missDD">
					<div className="lightT">
						<Autocomplete
						id="uploaded_by"
						options={uniqueUploadedBy}
						getOptionLabel={(option) => option['uploaded_by_name']}
						isOptionEqualToValue={(option, value) =>
							option.uploaded_by === value.uploaded_by
						}
						value={selectedUploadedBy}
						onChange={(event, newValue) => 
							setSelectedUploadedBy(newValue)
						}
						loading={getChildFiltersHook.isPending}
						loadingText="Loading..."
						renderInput={(params) => (
							<TextField {...params} label="Uploaded By" fullWidth />
						)}
						renderOption={(props, option) => (
							<li {...props} key={option.uploaded_by}>
								{option['uploaded_by_name']}
							</li>
						)}
						slotProps={{
							popper: {
								placement: 'bottom-start', 							
							},
						}}
					/>
						</div>
					</div>

					<div className="grow missDD">
					<div className="lightT">
						<Autocomplete
						id="fname"
						options={uniqueFnames}
						getOptionLabel={(option) => option['fname']}
						isOptionEqualToValue={(option, value) =>
							option._id === value._id
						}
						value={selectedFname}
						onChange={(event, newValue) =>
							setSelectedFname(newValue)
						}
						loading={getChildFiltersHook.isPending}
						loadingText="Loading..."
						renderInput={(params) => (
							<TextField {...params} label="File name" fullWidth />
						)}
						renderOption={(props, option) => (
							<li {...props} key={option._id}>
								{option['fname']}
							</li>
						)}
						slotProps={{
								popper: {
									placement: 'bottom-start', 							
								},
							}}
					/>
						</div>
					</div>

					<div className="grow missDD">
					<div className="lightT">
						<Autocomplete
						id="disp_status"
						options={uniqueDispStatus}
						getOptionLabel={(option) => option['disp_status']}
						isOptionEqualToValue={(option, value) =>
							option.disp_status === value.disp_status
						}
						value={selectedDispStatus}
						onChange={(event, newValue) =>
							setSelectedDispStatus(newValue)
						}
						loading={getChildFiltersHook.isPending}
						loadingText="Loading..."
						renderInput={(params) => (
							<TextField {...params} label="Status" fullWidth />
						)}
						renderOption={(props, option) => (
							<li {...props} key={option.disp_status}>
								{option['disp_status']}
							</li>
						)}
						slotProps={{
								popper: {
									placement: 'bottom-start', 							
								},
							}}
					/>
						</div>
					</div>

					<div className="grow missDD">
						<div className="lightT">
							<Autocomplete
							id="batch"
							options={uniqueBatches}
							getOptionLabel={(option) => option['batch']}
							isOptionEqualToValue={(option, value) =>
								option.batch_id === value.batch_id
							}
							value={selectedBatch}
							onChange={(event, newValue) =>
								setSelectedBatch(newValue)
							}
							loading={getChildFiltersHook.isPending}
							loadingText="Loading..."
							renderInput={(params) => (
								<TextField {...params} label="Batch" fullWidth />
							)}
							renderOption={(props, option) => (
								<li {...props} key={option.batch_id}>
									{option['batch']}
								</li>
							)}
							slotProps={{
								popper: {
									placement: 'bottom-start', 							
								},
							}}
						/>
							</div>
						</div>
					
</>
				)}

				{selectedClient && selectedVendor && selectedCategory && (
					<div className="grow missDD">
						<FilterFieldName
							setFieldName={setFieldName}
							FieldName={FieldName}
							setFieldNameId={setFieldNameId}
							FieldNameId={FieldNameId}
							AnalystId={selectedUploadedBy?.uploaded_by}
							CategoryId={selectedCategory?.category_id}
							ClientId={selectedClient?.client_id}
							VendorNameId={selectedVendor?.vendor_id}
						/>
					</div>
				)}


				<div className="dateHldr flex items-center gap-3">
					<div>From</div>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DemoContainer components={['DatePicker']}>
							<DatePicker
								slotProps={{ field: { clearable: true } }}
								value={fromValue || null}
								onChange={(event) => {
									setFromValue(event);
								}}
							/>
						</DemoContainer>
					</LocalizationProvider>
				</div>

				<div className="dateHldr flex items-center gap-3">
					<div>To</div>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DemoContainer components={['DatePicker']}>
							<DatePicker
								slotProps={{ field: { clearable: true } }}
								value={ToValue || null}
								onChange={(newValue) => setToValue(newValue)}
							/>
						</DemoContainer>
					</LocalizationProvider>
				</div>
				<div className="flex gap-1">
					<button
						type="button"
						disabled={get_dashboard_hook.isPending}
						onClick={resetFilters}
						className="bg-blue-800 hover:bg-indigo-700 w-full px-4 py-2 h-10 rounded-md text-white flex items-center font-black disabled:bg-slate-300 disabled:text-slate-700"
					>
						<span className="material-icons mr-1 text-sm">refresh</span>
						Reset
					</button>
					<button
						type="button"
						disabled={get_dashboard_hook.isPending}
						onClick={setDebounceSearch}
						className="bg-blue-800 hover:bg-indigo-700 w-full px-4 py-2 h-10 rounded-md text-white flex items-center font-black disabled:bg-slate-300 disabled:text-slate-700"
					>
						<span className="material-icons mr-1 text-sm">refresh</span>
						Reload
					</button>
				</div>
			</div>
		</>
	);
}
